/** @format */
import React, { useState } from 'react'
import { CustomPageContainer } from 'src/components'
import styled from 'styled-components'
import { _$, Card } from '@king-design/react'
import HeaderFilter from 'src/pages/AIObservability/components/HeaderFilter'
import { ServiceOverviewSearchProps } from 'src/pages/AIObservability/components/typescript'
import {
  initSearch,
  DEFAULT_HEADER_FILTER_RANGE
} from 'src/pages/AIObservability/components/constant'
import useNavRegion from 'src/hooks/useNavRegion'
import AgentKitOverview from './container/Overview'

const AgentKit: React.FC<{ className?: string }> = ({ className }) => {
  const [filterSearch, setFilterSearch] = useState<ServiceOverviewSearchProps>(initSearch())
  const [quickKey, setQuickKey] = useState<string>(DEFAULT_HEADER_FILTER_RANGE)

  // 控制台region
  const region = useNavRegion()

  return (
    <div className={className}>
      <CustomPageContainer title={_$('AgentKit 应用观测')}>
        <Card type="none">
          <HeaderFilter
            value={filterSearch}
            quickKey={quickKey}
            showAggregate={true}
            onChange={(value, range) => {
              setQuickKey(range)
              setFilterSearch(value)
            }}
          />
          <div className="agentkit-overview">
            {region ? (
              <AgentKitOverview
                quickKey={quickKey}
                startTime={filterSearch.time[0]}
                endTime={filterSearch.time[1]}
                region={region}
                step={filterSearch?.aggregateType}
              />
            ) : null}
          </div>
        </Card>
      </CustomPageContainer>
    </div>
  )
}

export default styled(AgentKit)`
  .agentkit-overview {
    margin-top: 24px;
  }
`
